import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ButtonBaseDefault from './ButtonBase';

const styleClass = {
  default: 'w-8 h-8',
};

class IconButton extends React.PureComponent {
  render() {
    let { className, children, ...other } = this.props;

    className = classNames(className, styleClass.default);

    return (
      <div>
        <ButtonBaseDefault className={className} {...other}>
          {children}
        </ButtonBaseDefault>
      </div>
    );
  }
}

IconButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  handler: PropTypes.func,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const IconButton = ({prop = val, className = '', handler = () => null }) =>

export default IconButton;
